/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_KeysInputs */

const en_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortcut Keys`)
};

const fr_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raccourcis clavier`)
};

const de_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombinationen`)
};

const it_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasti di scelta rapida`)
};

const ru_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сочетания клавиш`)
};

const es_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de acceso directo`)
};

const zh_cn2_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快捷键`)
};

const ja_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショートカットキー`)
};

const hi_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉर्टकट कुंजियाँ`)
};

const pt_pt2_shortcut_keys = /** @type {(inputs: Shortcut_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teclas de atalho`)
};

/**
* | output |
* | --- |
* | "Shortcut Keys" |
*
* @param {Shortcut_KeysInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys = /** @type {((inputs?: Shortcut_KeysInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_KeysInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys(inputs)
	if (locale === "de") return de_shortcut_keys(inputs)
	if (locale === "it") return it_shortcut_keys(inputs)
	if (locale === "ru") return ru_shortcut_keys(inputs)
	if (locale === "es") return es_shortcut_keys(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys(inputs)
	if (locale === "ja") return ja_shortcut_keys(inputs)
	if (locale === "hi") return hi_shortcut_keys(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys(inputs)
	return en_shortcut_keys(inputs)
});